import * as React from 'react';
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * Reusable FullScreenDialog Component
 * 
 * @param {boolean} open - Whether the dialog is open
 * @param {function} onClose - Callback to close the dialog
 * @param {function} onSave - Callback for save action
 * @param {string} title - Dialog title
 * @param {ReactNode} children - Body content
 */
export default function InvoiceApprovalDialog({
  open,
  onClose,
  onSave,
  title = "Dialog",
  children,
}) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar  className='invoice_topbar'>
          <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" className='invoice_topbar_text'>
            {title}
          </Typography>
          {/* {onSave && (
            <Button autoFocus color="inherit" onClick={onSave}>
              Proceed
            </Button>
          )} */}
        </Toolbar>
      </AppBar>
      {children}
    </Dialog>
  );
}
